import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  static timezoneOffset = (new Date).getTimezoneOffset()*60000;

  constructor() { }

  repeatUntilDone(callback: () => boolean, max: number, interval: number = 100) {
    let counter = 0;
    const i = setInterval(() => {
      counter++;
      if (counter > max || callback()) {
        clearInterval(i)
      }
    }, interval);
  }
}
